import { Colors } from '../../../../../styles'
import {
  Tooltips,
  ContentTooltips,
  TittleTooltips,
  TooltipsWrapper,
  TooltipItemWrapper,
} from '../../dashboard-jetty.styled'

export const TooltipEquipment = ({ data, id }) => {
  return (
    <TooltipsWrapper>
      <Tooltips
        id={id}
        backgroundColor={Colors.pureWhite}
        textColor={Colors.black}
      >
        <TooltipItemWrapper>
          <TittleTooltips>Name</TittleTooltips>
          <ContentTooltips>{data?.Name}</ContentTooltips>
        </TooltipItemWrapper>
        <TooltipItemWrapper>
          <TittleTooltips>Weight</TittleTooltips>
          <ContentTooltips>{data?.Weight}</ContentTooltips>
        </TooltipItemWrapper>
        <TooltipItemWrapper>
          <TittleTooltips>UOM</TittleTooltips>
          <ContentTooltips>{data?.UOM}</ContentTooltips>
        </TooltipItemWrapper>
      </Tooltips>
    </TooltipsWrapper>
  )
}
